import React, { Component } from "react";
import Close from "../Icons/Close";
import Img from "react-image";
import {
  fetchKids,
  getFilteredKids,
} from "../../src/modules/kids/kids-list/Kids-list.ducks";
import { connect } from "react-redux";
import { isNumber } from "util";
import {
  addPostCommunaute,
  uploadMomentPhotos,
  uploadMomentVideos,
} from "../modules/kids/kids-list/communaute/Communaute.duck";
import iconValider from "../styles/img/icon-check-white.svg";
import { css } from "@emotion/core";
import DotLoader from "react-spinners/DotLoader";
import _ from "lodash";
import { withTranslation } from 'react-i18next';

const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);

const divStyleAvatar = {
  color: "white",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundSize: "cover",
  position: "relative",
  width: "65px",
  height: "55px",
};
class SelectParentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disablePresent: false,
      disableInscrit: false,
      tabActive: "",
      Modal: false,
      filterPresent: "",
      readySubmit: false,
      childChecked: false,
      listChild: [],
      noCheck: true,
      listPresent: [],
      firstInit: false,
      presentIds: [],
      listKids: [],
      checkedValues: [],
      loading: true,
    };
    this.handleCheckKids = this.handleCheckKids.bind(this);
    this.checked = this.checked.bind(this);
    this.shaireWith = this.shaireWith.bind(this);
  }

  handleCheckKids(event) {
    var tab = this.state.checkedValues;
    var test = this.state.checkedValues.findIndex(
      (element) => element == event.currentTarget.dataset.id
    );
    if (test == -1) {
      tab.push(parseInt(event.currentTarget.dataset.id, 10));
      this.setState({ checkedValues: tab });
    } else {
      tab.splice(test, 1);
      this.setState({ checkedValues: tab });
    }
  }

  componentWillMount() {
    this.props.getFilteredKids(localStorage.getItem("token"));
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.kids.list.filterKids !== prevProps.kids.list.filterKids) {
      this.setState({
        listKids: this.props.kids.list.filterKids,
        loading: false,
      });
    }

    if (prevProps.loading !== this.props.loading) {
      if (prevProps.loading === true && this.props.loading === false) {
        this.props.onCloseModaleCamera();
      }
    }
  }

  checked(enfant) {
    var test = this.state.checkedValues.findIndex(
      (element) => element == enfant
    );
    if (test == -1) {
      return true;
    } else {
      return false;
    }
  }

  shaireWith = (event) => {
    event.preventDefault();
    var kids = this.props.kids.list.filterKids;
    var kidsParent = this.state.checkedValues;

    var ParentIds = [...new Set(kidsParent)];
    if (_.isEmpty(this.props.values.photo) === false) {
      let tok = localStorage.getItem("token");
      const data = {
        description: "description2",
        dataPost: this.props.dataPost,
        parentsList: ParentIds,
      };
      this.props.uploadMomentPhotos(tok, data);
    }
    if (_.isEmpty(this.props.values.photo) === true) {
      let tok = localStorage.getItem("token");
      const data = {
        video: this.props.values.file,
        parentsList: ParentIds,
      };
      this.props.uploadMomentVideos(tok, data);
    }
  };
  render() {
    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;
    return (
      <div
        className="modal fade modal-skin show"
        id="modalParents"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: "show", background: "rgba(0, 76, 197, 0.7)" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.props.onCloseModaleCamera}
              >
                <Close className="img-fluid" alt="" />
              </button>
              <div className="modal-body">
                <section>
                  <h5 className="modal-title">{this.props.t('share_modal.send_to_parents')}</h5>
                </section>

                {this.props.loading === true ? (
                  <DotLoader
                    size={100}
                    color={"#ff7d26"}
                    css={override}
                    loading={this.props.loading}
                  />
                ) : (
                  <section>
                    <ul className="row mx-n2 list-enfants ">
                      {this.state.listKids.length > 0 ? (
                        this.props.kids.list.filterKids.map((element) => (
                          <li
                            className="col-md-6 px-2"
                            onClick={this.handleCheckKids}
                            data-id={element.id}
                          >
                            <input
                              type="checkbox"
                              checked={
                                this.checked(element.id) === false
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="rounded15 box-shadow"
                              htmlFor={`${element.id}`}
                            >
                              <span
                                className="avatar"
                                style={{
                                  color: "white",
                                  backgroundImage:
                                    "url(" + element.lienPhoto + ")",
                                  backgroundRepeat: "no-repeat",
                                  backgroundPosition: "center center",
                                  backgroundSize: "cover",
                                  position: "relative",
                                  width: "65px",
                                  height: "55px",
                                }}
                              />
                              {element.nom === undefined ? (
                                <span className="name"></span>
                              ) : (
                                <span className="name">
                                  {element.nom + " " + element.prenom}.
                                </span>
                              )}
                            </label>
                          </li>
                        ))
                      ) : (
                        <DotLoader
                          size={100}
                          color={"#ff7d26"}
                          css={override}
                          loading={this.state.loading}
                        />
                      )}
                    </ul>
                  </section>
                )}
                <div className="d-flex justify-content-center">
                  <button
                    type="submit"
                    className="btn-gradient btn-valid"
                    data-dismiss="modal"
                    onClick={this.shaireWith}
                  >
                    <IconValider />
                    {this.props.t('common.validate')}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ kids }) => ({
  kids,
});

const mapDispatchToProps = {
  getFilteredKids,
  fetchKids,
  addPostCommunaute,
  uploadMomentPhotos,
  uploadMomentVideos,
};

const withStore = connect(mapStateToProps, mapDispatchToProps);

export default withStore(withTranslation()(SelectParentModal));
